import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import { load } from '@/util/router-utils.js'

import client from './client'
import superAdmin from './super-admin'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/app'
    },
    {
      name: 'auth',
      path: '/auth',
      component: load('auth/Index')
    },
    {
      name: 'app',
      path: '/app',
      component: load('app/Index'),
      children: [
        ...client,
        ...superAdmin
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (!store.getters.clientId && to.params.client_id) {
    store.dispatch('setClientId', to.params.client_id)
  }
  if (store.getters['account/isAuth'] && to.path.includes('auth')) {
    next(false)
  } else {
    next()
  }
})

export default router
